import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useStyles } from './styles';
import { EditorContent } from './EditorContent';
import { EditorDialogs } from './EditorDialogs';
import { EditorFooter } from './EditorFooter';
import {
  CustomSpotsEditorProps,
  useCustomSpotsEditor,
} from './useCustomSpotsEditor';

const CustomSpotsEditor: React.FC<CustomSpotsEditorProps> = ({
  open,
  onClose,
}) => {
  const classes = useStyles();
  const controller = useCustomSpotsEditor({ onClose });

  return (
    <>
      <Dialog
        open={open}
        onClose={controller.handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: classes.paper }}
      >
        <DialogTitle sx={classes.title}>
          {controller.dialogTitle}
          <IconButton
            sx={classes.closeButton}
            onClick={controller.handleClose}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={classes.content}>
          <EditorContent classes={classes} controller={controller} />
        </DialogContent>

        <Box sx={classes.footer}>
          <EditorFooter classes={classes} controller={controller} />
        </Box>
      </Dialog>

      <EditorDialogs classes={classes} controller={controller} />
    </>
  );
};

export default CustomSpotsEditor;
